import { render, staticRenderFns } from "./edit-email-form.vue?vue&type=template&id=66f28950"
import script from "./edit-email-form.vue?vue&type=script&lang=js"
export * from "./edit-email-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports